export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/CodeWorker.423fdb42.worker.js");
}
